import { createMuiTheme } from '@material-ui/core/styles';
import { HIRAGINO_FONT } from '../../shared/styles/styleConstants';
// TODO coreへの依存をなくす
import {
  servicePaletteOptions as palette,
  props,
  overrides as coreOverrides,
} from '../../core/styles';

const typography = {
  fontFamily: HIRAGINO_FONT,
};

const overrides = {
  ...coreOverrides,
  MuiPaper: {
    root: {
      outline: 'none !important',
    },
  },
  MuiFormControlLabel: {
    label: {
      fontSize: '.9rem',
    },
  },
  MuiFormLabel: {
    root: {
      fontSize: '.9rem',
    },
  },
  MuiListItem: {
    button: {
      '&:hover': {
        backgroundColor: palette.action.selected,
      },
    },
  },
};

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  props,
  shape: { borderRadius: 5 },
});
const darkTheme = createMuiTheme({
  palette: { ...palette, type: 'dark' },
  typography,
  overrides,
  props,
});

export { theme, darkTheme };

export const makeContainerStyles = (theme) => ({
  padding: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 2),
  },
});
